import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";

const UpdateFileDataLibrary = ({ Show, Hide, Title, getEDCLupDataLibrary, fileData, updateType }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileLabel, setFileLabel] = useState("");
  const [type, setType] = useState("");
  const [error, setError] = useState("");
  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateDataLibraryFileAndDataset = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${updateType === "update" ? "Change Title" : "Move"} of this File?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${updateType === "update" ? "Change" : "Move"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        let data
        userData.id = fileData?._id
        userData.uniqueId = fileData?.uniqueId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        if (updateType === "update") {
          userData.name = fileName;
          userData.label = fileLabel;
        } else {
          userData.type = type;
        }
        data = await studyEDCLupReportingServices.updateDataLibraryFileAndDataset(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEDCLupDataLibrary();
          setFileName("")
          setFileLabel("")
          setError("")
          Hide()
        }
      }
    });
  };

  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setFileName(fileData?.name);
    setFileLabel(fileData?.label);
    setType(fileData?.type);
  }, [fileData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {updateType === "update" ?
            <>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                File Name{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                value={fileName}
                onChange={(e) => {
                  setFileName(e.target.value);
                  validateFileTitle(e.target.value);
                }}
                placeholder="Enter File Title"
                required
              />
              {error && (
                <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                  File Title should only contain capital letters, small letters,
                  underScore, and numbers "Space Not Allowed"
                </span>
              )}
            </Form.Group>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                File Label{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                value={fileLabel}
                onChange={(e) => setFileLabel(e.target.value)}
                placeholder="Enter File Label"
                required
              />
            </Form.Group>
            </>
            :
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold">
                Select Library{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                aria-label="Default select example"
                onChange={(e) => setType(e.target.value)}
                value={type}
                required
              >
                <option selected={type === ""} value="">Select Library</option>
                <option selected={type === "Analysis"} value="Analysis">Analysis</option>
                <option selected={type === "Standard"} value="Standard">Standard</option>
                <option selected={type === "Raw"} value="Raw">Raw</option>
                <option selected={type === "Temp"} value="Temp">Temp</option>
              </Form.Select>
            </Form.Group>
          }
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            disabled={
              updateType === "update" ?
                (buttonLoader || !fileName || !fileLabel || error)
                :
                (buttonLoader || !type)
            }
            title={Title}
            className="updateProfile"
            onClick={() => {
              updateDataLibraryFileAndDataset();
            }}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> {updateType === "update" ? "Updating..." : "Moving"}
              </div>
            ) : (
              updateType === "update" ? "Update" : "Move"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateFileDataLibrary;
